import ClientDetails from './ClientDetails';
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API } from '../config';
import CompanyDetails from './CompanyDetails';

const STATUS_AR = { searching:'🔍 بحث', accepted:'✅ مقبول', in_transit:'🚀 جاري', delivered:'🎉 تم', cancelled:'❌ ملغي', failed:'😔 فشل' };
const STATUS_COLOR = { searching:'#f59e0b', accepted:'#10b981', in_transit:'#3b82f6', delivered:'#10b981', cancelled:'#ef4444', failed:'#ef4444' };

export default function Dashboard({ token, onLogout }) {
  const [page, setPage] = useState('home');
  const [stats, setStats] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [clients, setClients] = useState([]);
  const [settings, setSettings] = useState([]);
  const [topupRequests, setTopupRequests] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const [success, setSuccess] = useState('');
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedDriver, setSelectedDriver] = useState(null);

  const load = useCallback(() => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    axios.get(`${API}/admin/dashboard`).then(r => setStats(r.data)).catch(() => {});
    axios.get(`${API}/companies`).then(r => setCompanies(r.data.companies || [])).catch(() => {});
    axios.get(`${API}/drivers`).then(r => setDrivers(r.data.drivers || [])).catch(() => {});
    axios.get(`${API}/orders`).then(r => setOrders(r.data.orders || [])).catch(() => {});
    axios.get(`${API}/admin/clients`).then(r => setClients(r.data.users || [])).catch(() => {});
    axios.get(`${API}/admin/settings`).then(r => setSettings(r.data.settings || [])).catch(() => {});
    axios.get(`${API}/wallet/pending-topups`).then(r => setTopupRequests(r.data.requests || [])).catch(() => {});
  }, [token]);

  useEffect(() => { load(); }, [load]);

  const openModal = (type, data = {}) => { setModal(type); setForm(data); setErr(''); setSuccess(''); };
  const closeModal = () => { setModal(null); setForm({}); setErr(''); setSuccess(''); };

  const handleSubmit = async () => {
    setLoading(true); setErr('');
    try {
      if (modal === 'approve_company') {
        await axios.patch(`${API}/companies/${form.id}/status`, { status: 'payment_pending' });
        setSuccess('تم إرسال رابط الدفع');
        load();
      } else if (modal === 'reject_company') {
        await axios.patch(`${API}/companies/${form.id}/status`, { status: 'rejected', rejection_reason: form.rejection_reason });
        setSuccess('تم رفض الشركة');
        load();
      } else if (modal === 'confirm_payment') {
        await axios.patch(`${API}/companies/${form.id}/status`, { status: 'approved' });
        setSuccess('تم تأكيد الدفع');
        load();
      } else if (modal === 'suspend_company') {
        await axios.patch(`${API}/companies/${form.id}/status`, { status: 'suspended' });
        setSuccess('تم إيقاف الشركة');
        load();
      } else if (modal === 'approve_driver') {
        await axios.patch(`${API}/drivers/${form.id}/status`, { status: 'approved' });
        setSuccess('تم اعتماد الطيار');
        load();
      } else if (modal === 'reject_driver') {
        await axios.patch(`${API}/drivers/${form.id}/status`, { status: 'rejected', rejection_reason: form.rejection_reason || 'غير مستوفٍ للشروط' });
        setSuccess('تم رفض الطيار');
        load();
      } else if (modal === 'add_client') {
        await axios.post(`${API}/auth/register`, { full_name: form.full_name, phone: form.phone, password: form.password, role: 'client' });
        setSuccess('تم إضافة العميل بنجاح');
        load();
      } else if (modal === 'add_company') {
        await axios.post(`${API}/companies/register`, { company_name: form.company_name, email: form.email, phone: form.phone, address: form.address, national_id: form.national_id, admin_name: form.admin_name, admin_phone: form.admin_phone, admin_password: form.admin_password });
        setSuccess('تم إضافة الشركة');
        load();
      } else if (modal === 'settings') {
        await axios.patch(`${API}/admin/settings`, { key: form.key, value: form.value });
        setSuccess('تم الحفظ');
        load();
      }
    } catch (e) {
      setErr(e.response?.data?.error || 'حصل خطأ');
    }
    setLoading(false);
  };

  if (selectedCompany) return (
    <CompanyDetails companyId={selectedCompany.id} token={token} onBack={() => { setSelectedCompany(null); load(); }} />
  );

  if (selectedClient) return <ClientDetails clientId={selectedClient} token={localStorage.getItem('admin_token')} onBack={()=>setSelectedClient(null)} />;

  const navItems = [['home','🏠','الرئيسية'],['companies','🏢','الشركات'],['drivers','🛵','الطيارين'],['orders','📦','الطلبات'],['clients','👥','العملاء'],['revenue','💰','الإيرادات'],['settings','⚙️','الإعدادات'],['wallet','💳','الشحن']];

  return (
    <div style={S.app}>
      <div style={S.sidebar}>
        <div style={S.sideTop}>
          <div style={S.sideLogo}>⚡</div>
          <h1 style={S.sideTitle}>بسرعة</h1>
          <p style={S.sideSub}>لوحة تحكم الإدارة</p>
        </div>
        <nav style={S.nav}>
          {navItems.map(([id,ic,lb]) => (
            <button key={id} style={{...S.navBtn,...(page===id?S.navActive:{})}} onClick={()=>setPage(id)}>
              <span style={S.navIcon}>{ic}</span><span>{lb}</span>
            </button>
          ))}
        </nav>
        <div style={S.sideBottom}>
          <p style={{color:'#94a3b8',fontSize:'12px',marginBottom:'8px'}}>مسجل كـ</p>
          <p style={{color:'#fff',fontWeight:'bold',fontSize:'14px'}}>Super Admin</p>
          <button onClick={onLogout} style={S.logoutBtn}>🚪 تسجيل الخروج</button>
        </div>
      </div>

      <div style={S.main}>
        {page==='home' && stats && (
          <>
            <div style={S.header}><h1 style={S.pageTitle}>الرئيسية</h1></div>
            <div style={S.grid4}>
              {[['📦',stats.orders?.total||0,'إجمالي الطلبات'],['🎉',stats.orders?.completed||0,'طلبات مكتملة'],['🏢',stats.companies?.active||0,'شركات نشطة'],['🛵',stats.drivers?.online||0,'طيارين online']].map(([ic,n,lb])=>(
                <div key={lb} style={S.statCard}><div style={S.statIcon}>{ic}</div><div style={S.statNum}>{n}</div><div style={S.statLabel}>{lb}</div></div>
              ))}
            </div>
            <div style={S.grid3}>
              {[['💰',parseFloat(stats.revenue?.total_gmv||0).toFixed(0)+' ج','إجمالي قيمة الطلبات'],['🏦',parseFloat(stats.revenue?.total_platform_revenue||0).toFixed(0)+' ج','إيرادات المنصة'],['🏢',parseFloat(stats.revenue?.total_company_payouts||0).toFixed(0)+' ج','مدفوعات الشركات']].map(([ic,n,lb])=>(
                <div key={lb} style={S.statCard}><div style={S.statIcon}>{ic}</div><div style={S.statNum}>{n}</div><div style={S.statLabel}>{lb}</div></div>
              ))}
            </div>
            <div style={S.grid4}>
              {[['⏳',stats.companies?.pending_approval||0,'شركات تنتظر موافقة'],['⏳',stats.drivers?.pending_approval||0,'طيارين تنتظر موافقة'],['🔍',stats.orders?.searching||0,'طلبات بحث'],['🚀',stats.orders?.in_transit||0,'طلبات جارية']].map(([ic,n,lb])=>(
                <div key={lb} style={S.statCard}><div style={S.statIcon}>{ic}</div><div style={S.statNum}>{n}</div><div style={S.statLabel}>{lb}</div></div>
              ))}
            </div>
          </>
        )}

        {page==='companies' && (
          <>
            <div style={S.header}>
              <h1 style={S.pageTitle}>الشركات</h1>
              <div style={{display:'flex',gap:'10px',alignItems:'center'}}>
              <button style={S.addBtn} onClick={()=>openModal('add_company')}>+ إضافة شركة</button>
              <button style={{...S.addBtn,background:'#0f172a',border:'1px solid #334155'}} onClick={()=>{navigator.clipboard.writeText('https://besor3a.com/register-company');alert('تم نسخ الرابط!')}}>🔗 رابط التسجيل</button>
            </div>
            </div>
            <div style={S.card}>
              <table style={S.table}>
                <thead><tr>{['الاسم','الإيميل','الهاتف','الحالة','نسبة المنصة','الاشتراك','طيارين'].map(h=><th key={h} style={S.th}>{h}</th>)}</tr></thead>
                <tbody>
                  {companies.map(c=>(
                    <tr key={c.id} style={{cursor:'pointer'}} onClick={()=>setSelectedCompany(c)}>
                      <td style={S.td}>{c.name} →</td>
                      <td style={S.td}>{c.email}</td>
                      <td style={S.td}>{c.phone}</td>
                      <td style={S.td}><span style={S.badge(c.status==='approved'?'#10b981':c.status==='pending'?'#f59e0b':'#ef4444')}>{c.status}</span></td>
                      <td style={S.td}>{c.platform_fee_pct}%</td>
                      <td style={S.td}>{c.subscription_paid?'✅ مدفوع':'❌'}</td>
                      <td style={S.td}>{c.driver_count||0}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}

        {page==='drivers' && (
          <>
            <div style={S.header}><h1 style={S.pageTitle}>الطيارين</h1></div>
            <div style={S.card}>
              <table style={S.table}>
                <thead><tr>{['الاسم','الهاتف','الشركة','المركبة','الحالة','التوفر','الرحلات','التقييم','إجراءات'].map(h=><th key={h} style={S.th}>{h}</th>)}</tr></thead>
                <tbody>
                  {drivers.map(d=>(
                    <tr key={d.id}>
                      <td style={S.td}>{d.full_name}</td>
                      <td style={S.td}>{d.phone}</td>
                      <td style={S.td}>{d.company_name||'—'}</td>
                      <td style={S.td}>{d.vehicle_type}</td>
                      <td style={S.td}><span style={S.badge(d.status==='approved'?'#10b981':d.status==='pending'?'#f59e0b':'#ef4444')}>{d.status}</span></td>
                      <td style={S.td}><span style={S.badge(d.availability==='online'?'#10b981':d.availability==='busy'?'#f59e0b':'#64748b')}>{d.availability}</span></td>
                      <td style={S.td}>{d.total_trips||0}</td>
                      <td style={S.td}>⭐ {d.avg_rating||'—'}</td>
                      <td style={S.td}>
                        {d.status==='pending' && <button style={{...S.actionBtnGreen,marginLeft:'4px'}} onClick={()=>openModal('approve_driver',{id:d.id,name:d.full_name})}>✅</button>}
                        {d.status==='approved' && <button style={{...S.actionBtnRed}} onClick={()=>openModal('reject_driver',{id:d.id,name:d.full_name})}>⏸</button>}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}

        {page==='orders' && (
          <>
            <div style={S.header}><h1 style={S.pageTitle}>الطلبات <span style={{fontSize:'14px',color:'#94a3b8'}}>{orders.length} طلب</span></h1></div>
            <div style={S.card}>
              <table style={S.table}>
                <thead><tr>{['العميل','الطيار','الشركة','من','إلى','السعر','الحالة','ملغي بواسطة','التاريخ'].map(h=><th key={h} style={S.th}>{h}</th>)}</tr></thead>
                <tbody>
                  {orders.map(o=>(
                    <tr key={o.id}>
                      <td style={S.td}>{o.client_name}</td>
                      <td style={S.td}>{o.driver_name||'—'}</td>
                      <td style={S.td}>{o.company_name||'—'}</td>
                      <td style={{...S.td,maxWidth:'120px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{o.pickup_address}</td>
                      <td style={{...S.td,maxWidth:'120px',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{o.dropoff_address}</td>
                      <td style={S.td}>{o.base_price} ج</td>
                      <td style={S.td}><span style={S.badge(STATUS_COLOR[o.status]||'#94a3b8')}>{STATUS_AR[o.status]||o.status}</span></td>
                      <td style={S.td}>{o.status==='cancelled'?(o.cancelled_by_name||'—'):'—'}</td>
                      <td style={S.td}>{new Date(o.requested_at).toLocaleDateString('ar-EG')}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}

        {page==='clients' && (
          <>
            <div style={S.header}>
              <h1 style={S.pageTitle}>العملاء</h1>
              <button style={S.addBtn} onClick={()=>openModal('add_client')}>+ إضافة عميل</button>
            </div>
            <div style={S.card}>
              <table style={S.table}>
                <thead><tr>{['الاسم','الهاتف','الحالة','تاريخ التسجيل',''].map(h=><th key={h} style={S.th}>{h}</th>)}</tr></thead>
                <tbody>
                  {clients.map(c=>(
                    <tr key={c.id} onClick={()=>setSelectedClient(c.id)} style={{cursor:'pointer'}}>
                      <td style={S.td}>{c.full_name}</td>
                      <td style={S.td}>{c.phone}</td>
                      <td style={S.td}><span style={S.badge(c.is_active===false?'#ef4444':'#10b981')}>{c.is_active===false?'موقوف':'نشط'}</span></td>
                      <td style={S.td}>{new Date(c.created_at).toLocaleDateString('ar-EG')}</td>
                      <td style={S.td}><button onClick={async()=>{await axios.patch(`${API}/admin/clients/${c.id}/toggle`);axios.get(`${API}/admin/clients`).then(r=>setClients(r.data.users||[]));}} style={{padding:'4px 10px',background:c.is_active===false?'#10b981':'#ef4444',color:'#fff',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'12px'}}>{c.is_active===false?'✅ تفعيل':'⏸ إيقاف'}</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}

        {page==='revenue' && (
          <>
            <div style={S.header}><h1 style={S.pageTitle}>الإيرادات</h1></div>
            {stats && <div style={S.grid3}>
              {[['💰',parseFloat(stats.revenue?.total_gmv||0).toFixed(0)+' ج','إجمالي قيمة الرحلات'],['🏦',parseFloat(stats.revenue?.total_platform_revenue||0).toFixed(0)+' ج','نصيب المنصة'],['🏢',parseFloat(stats.revenue?.total_company_payouts||0).toFixed(0)+' ج','نصيب الشركات']].map(([ic,n,lb])=>(
                <div key={lb} style={S.statCard}><div style={S.statIcon}>{ic}</div><div style={S.statNum}>{n}</div><div style={S.statLabel}>{lb}</div></div>
              ))}
            </div>}
          </>
        )}

        {page==='settings' && (
          <>
            <div style={S.header}><h1 style={S.pageTitle}>الإعدادات</h1></div>
            <div style={S.card}>
              <div style={{padding:'20px'}}>
                {[['base_fare','سعر الفتح (جنيه)'],['price_per_km','سعر الكيلومتر (جنيه)'],['default_platform_fee_pct','نسبة المنصة الافتراضية (%)'],['default_subscription_fee','رسوم الاشتراك (جنيه)'],['driver_search_radius_km','نطاق البحث عن طيار (كم)'],['driver_offer_timeout_sec','مهلة رد الطيار (ثانية)'],['max_offer_attempts','أقصى عدد محاولات'],['min_order_price','أقل سعر للرحلة (جنيه)']].map(([key,label])=>(
                  <div key={key} style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'14px 0',borderBottom:'1px solid #334155'}}>
                    <span style={{color:'#e2e8f0',fontSize:'14px'}}>{label}</span>
                    <button style={{...S.addBtn,fontSize:'12px',padding:'6px 14px'}} onClick={()=>openModal('settings',{key,value:'',label})}>تعديل</button>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}

        {page==='wallet' && (
          <>
            <div style={S.header}><h1 style={S.pageTitle}>💳 طلبات شحن المحفظة <span style={{fontSize:'14px',color:'#94a3b8'}}>{topupRequests.length} طلب</span></h1></div>
            {topupRequests.length === 0 ? (
              <div style={{textAlign:'center',padding:'60px',color:'#94a3b8'}}>
                <p style={{fontSize:'48px'}}>✅</p>
                <p>لا توجد طلبات معلقة</p>
              </div>
            ) : topupRequests.map(r => (
              <div key={r.id} style={{...S.card, padding:'20px', marginBottom:'12px', display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <div>
                  <p style={{color:'#fff', fontWeight:'bold', margin:'0 0 4px'}}>{r.full_name} — {r.phone}</p>
                  <p style={{color:'#94a3b8', fontSize:'13px', margin:'0 0 4px'}}>{r.description}</p>
                  <p style={{color:'#f59e0b', fontSize:'13px', margin:0}}>{new Date(r.created_at).toLocaleString('ar-EG')}</p>
                  {r.reference && r.reference.startsWith('/uploads') && (
                    <a href={'https://besor3a.com'+r.reference} target="_blank" rel="noreferrer" style={{color:'#93c5fd',fontSize:'13px'}}>📷 عرض الإيصال</a>
                  )}
                </div>
                <div style={{textAlign:'center'}}>
                  <p style={{color:'#10b981', fontSize:'24px', fontWeight:'bold', margin:'0 0 8px'}}>{parseFloat(r.amount).toFixed(2)} ج</p>
                  <button onClick={async () => {
                    try {
                      await axios.post(`${API}/wallet/confirm-topup/${r.id}`);
                      load();
                    } catch(e) { alert(e.response?.data?.error || 'حصل خطأ'); }
                  }} style={{padding:'8px 16px', background:'#10b981', color:'#fff', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'bold'}}>✅ موافقة</button>
                </div>
              </div>
            ))}
          </>
        )}
        {modal && (
          <div style={S.modal} onClick={e=>e.target===e.currentTarget&&closeModal()}>
            <div style={S.modalBox}>
              <div style={S.modalTitle}>
                {modal==='add_company'&&'إضافة شركة'}{modal==='add_client'&&'إضافة عميل'}{modal==='approve_driver'&&`موافقة: ${form.name}`}{modal==='reject_driver'&&`رفض: ${form.name}`}{modal==='settings'&&`تعديل: ${form.label}`}{modal==='approve_company'&&`موافقة: ${form.name}`}{modal==='reject_company'&&`رفض: ${form.name}`}{modal==='confirm_payment'&&`تأكيد دفع: ${form.name}`}{modal==='suspend_company'&&`إيقاف: ${form.name}`}
              </div>
              {err && <div style={S.errBox}>{err}</div>}
              {success && <div style={S.successBox}>{success}</div>}
              {['add_company'].includes(modal) && ['company_name','email','phone','address','national_id','admin_name','admin_phone','admin_password'].map(k=>(
                <div key={k} style={S.field}><label style={S.label}>{k}</label><input style={S.input} value={form[k]||''} onChange={e=>setForm({...form,[k]:e.target.value})} type={k.includes('password')?'password':'text'}/></div>
              ))}
              {modal==='add_client' && ['full_name','phone','password'].map(k=>(
                <div key={k} style={S.field}><label style={S.label}>{k}</label><input style={S.input} value={form[k]||''} onChange={e=>setForm({...form,[k]:e.target.value})} type={k==='password'?'password':'text'}/></div>
              ))}
              {modal==='reject_driver' && <div style={S.field}><label style={S.label}>سبب الرفض</label><input style={S.input} value={form.rejection_reason||''} onChange={e=>setForm({...form,rejection_reason:e.target.value})}/></div>}
              {modal==='settings' && <div style={S.field}><label style={S.label}>القيمة الجديدة</label><input style={S.input} value={form.value||''} onChange={e=>setForm({...form,value:e.target.value})}/></div>}
              {!success && <button style={S.submitBtn} onClick={handleSubmit} disabled={loading}>{loading?'⏳ جاري...':'حفظ ✓'}</button>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const S = {
  app:{display:'flex',height:'100vh',background:'#0f172a',direction:'rtl',fontFamily:'system-ui,sans-serif'},
  sidebar:{width:'220px',background:'#1e293b',display:'flex',flexDirection:'column',flexShrink:0},
  sideTop:{padding:'24px 16px',borderBottom:'1px solid #334155',textAlign:'center'},
  sideLogo:{fontSize:'36px',marginBottom:'8px'},
  sideTitle:{color:'#fff',fontSize:'20px',fontWeight:'bold',margin:'0 0 4px'},
  sideSub:{color:'#94a3b8',fontSize:'12px',margin:0},
  nav:{flex:1,padding:'16px 8px',display:'flex',flexDirection:'column',gap:'4px'},
  navBtn:{display:'flex',alignItems:'center',gap:'10px',padding:'10px 12px',background:'none',border:'none',color:'#94a3b8',cursor:'pointer',borderRadius:'8px',fontSize:'14px',textAlign:'right',width:'100%'},
  navActive:{background:'#6366f1',color:'#fff'},
  navIcon:{fontSize:'18px'},
  sideBottom:{padding:'16px',borderTop:'1px solid #334155'},
  logoutBtn:{width:'100%',padding:'8px',background:'#ef4444',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontSize:'13px',marginTop:'8px'},
  main:{flex:1,overflow:'auto',padding:'24px'},
  header:{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'24px'},
  pageTitle:{color:'#fff',fontSize:'24px',fontWeight:'bold',margin:0},
  grid4:{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:'16px',marginBottom:'16px'},
  grid3:{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'16px',marginBottom:'16px'},
  statCard:{background:'#1e293b',borderRadius:'12px',padding:'20px',textAlign:'center'},
  statIcon:{fontSize:'28px',marginBottom:'8px'},
  statNum:{color:'#fff',fontSize:'24px',fontWeight:'bold',marginBottom:'4px'},
  statLabel:{color:'#94a3b8',fontSize:'13px'},
  card:{background:'#1e293b',borderRadius:'12px',overflow:'hidden'},
  table:{width:'100%',borderCollapse:'collapse'},
  th:{padding:'12px 16px',textAlign:'right',color:'#94a3b8',fontSize:'13px',borderBottom:'1px solid #334155',background:'#0f172a'},
  td:{padding:'12px 16px',color:'#e2e8f0',fontSize:'13px',borderBottom:'1px solid #1e293b'},
  badge:(c)=>({display:'inline-block',padding:'3px 10px',borderRadius:'20px',fontSize:'11px',fontWeight:'bold',background:c+'22',color:c}),
  addBtn:{padding:'8px 16px',background:'#6366f1',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontSize:'14px',fontWeight:'bold'},
  actionBtnGreen:{padding:'4px 10px',background:'#10b981',color:'#fff',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'12px'},
  actionBtnRed:{padding:'4px 10px',background:'#ef4444',color:'#fff',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'12px'},
  modal:{position:'fixed',inset:0,background:'rgba(0,0,0,0.7)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999},
  modalBox:{background:'#1e293b',borderRadius:'16px',padding:'24px',width:'400px',maxHeight:'80vh',overflow:'auto'},
  modalTitle:{color:'#fff',fontSize:'18px',fontWeight:'bold',marginBottom:'16px'},
  errBox:{background:'#7f1d1d',color:'#fca5a5',padding:'10px',borderRadius:'8px',marginBottom:'12px',fontSize:'13px'},
  successBox:{background:'#14532d',color:'#86efac',padding:'10px',borderRadius:'8px',marginBottom:'12px',fontSize:'13px'},
  field:{marginBottom:'12px'},
  label:{display:'block',color:'#94a3b8',fontSize:'12px',marginBottom:'4px'},
  input:{width:'100%',padding:'8px 12px',background:'#0f172a',border:'1px solid #334155',borderRadius:'8px',color:'#fff',fontSize:'14px',boxSizing:'border-box'},
  submitBtn:{width:'100%',padding:'10px',background:'#6366f1',color:'#fff',border:'none',borderRadius:'8px',cursor:'pointer',fontSize:'15px',fontWeight:'bold'},
};
